import { AppLayout } from 'layouts';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { message } from 'ui';
import { useLogout } from 'common/services/hooks';
import type { StatusType } from 'features/dexcom';
import { Settings } from 'features/settings';
import { useSettingsTabsParams } from './hooks';

const PageSettings = () => {
  const tabOptions = useSettingsTabsParams();
  const location = useLocation();

  const navigate = useNavigate();

  const logout = useLogout();

  const dexcomOnFinished = useCallback(
    async ({ messageText, status }: { messageText: string; status: StatusType }) => {
      switch (status) {
        case 'abort':
          message.error(messageText);
          break;
        case 'error':
          message.error(messageText);
          break;
        case 'success':
          message.success(messageText);
          break;
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      if (location.state?.backUrl) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        await navigate(location.state.backUrl);
      }
    },
    [location.state, navigate],
  );

  return (
    <AppLayout>
      <Settings
        dexcomSync={{
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          automaticSync: location.state?.automaticSync ?? false,
          onFinished: dexcomOnFinished,
        }}
        logOut={logout}
        tabOptions={tabOptions}
      />
    </AppLayout>
  );
};

export default PageSettings;
